import type { ThemeConfig } from 'antd';

/**
 * 全局主题配置（M1 使用 Ant Design 默认色板）
 * M6 报告页设计定稿后，可在此收敛品牌色、圆角、字体等设计令牌。
 */
export const themeConfig: ThemeConfig = {
  token: {
    colorPrimary: '#1677ff',
    colorInfo: '#1677ff',
    borderRadius: 8,
    fontSize: 14,
  },
};
